export default __webpack_public_path__ + "static/media/book-search-engine.390472a3.png";